// extracted by mini-css-extract-plugin
export var brand = "_3s-9";
export var compact = "_3s-6";
export var extraSmall = "_3s-7";
export var icon = "_3s-0";
export var large = "_3s-4";
export var light = "_3s-1";
export var medium = "_3s-5";
export var outline = "_3s-b";
export var primaryDark = "_3s-a";
export var primaryLight = "_3s-8";
export var primaryModern = "_3s-c";
export var success = "_3s-2";
export var successSolid = "_3s-3";